/**
 * Represents a client-side tag manager script configured in {@link TrackingConfig}.
 *
 * @stable
 */
export interface ClientTagManager {
    name: string;
    script: string;
}

/**
 * @stable
 */
export interface TrackingServiceOptions {
    timeout: number;
}

/**
 * @stable
 */
export interface EventNames {
    pageView: string;
    userLogout: string;
}

/**
 * @internal
 */
export const eventNames: EventNames = {
    pageView: 'pageView',
    userLogout: 'Event.Logout',
};

/**
 * @internal
 */
export interface CommunicationType {
    id: string;
    name: string;
    selected: boolean;
}

/**
 * @internal
 */
export interface CommunicationSettings {
    settings: CommunicationType[];
}

/**
 * @internal
 */
export interface ContentItemTracking {
    event: string;
    data: { [key: string]: string };
}

/**
 * Represents a request to send measurement events to Google Analytics 4 (GA4) using the Measurement Protocol.
 *
 * @stable
 */
export interface MeasurementEvent {
    client_id?: string;
    user_id?: string;
    timestamp_micros: number;
    user_properties: Record<string, string | undefined>[];
    events: Ga4Event[];
}

/**
 * Represents an event to be sent to Google Analytics 4 (GA4) using the Measurement Protocol.
 *
 * @stable
 */
export interface Ga4Event {
    name: string;
    params: Ga4EventParams;
}

/**
 * Represents the parameters for an event to be sent to Google Analytics 4 (GA4) using the Measurement Protocol.
 *
 * @stable
 */
export interface Ga4EventParams extends Record<string, object | string | undefined> {
    items: Record<string, string>[];
}
